import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) top / cover no-repeat`}
          column
          alignCenter
          justifyCenter
        >
          {/* <Header />*/}
          <CFView textCenter w="100%">
            <CFView>
              <CFImage
                w="228px"
                src={mobileHeroText}
                alt="Kita no donburi Bar hero text"
                zIndex={98}
              />
            </CFView>
            <CFView pulsate mt="30px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignCenter
        >
          {/*<Header />*/}
          <CFView column justifyCenter alignCenter mt="20px">
            <CFImage
              w="285px"
              src={heroText}
              alt="Kita no donburi Bar hero text"
              zIndex={98}
            />
            <CFView pulsate mt="40px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
